import { Component, Input, OnInit } from '@angular/core';
import { RenaultUserAnimationDataDTO } from '../../../models/renault-user-dto';

@Component({
  selector: 'animation-action-user-card',
  templateUrl: './animation-action-user-card.component.html',
  styleUrls: ['./animation-action-user-card.component.scss']
})
export class AnimationActionUserCardComponent implements OnInit {

  @Input() model: RenaultUserAnimationDataDTO;
  

  constructor() { }

  ngOnInit(): void {
  
  }

  


}
